import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import ImgGallery from "components/layout/ImageGallery";

import heroBanner from "assets/images/pages/golf-and-grow/main_banner.jpg";

import {
  golfAndGrowPatioImages,
  golfAndGrowDrivingRangeImages,
  golfAndGrowCoachingImages,
} from "utils/constants/data";

function GolfAndGrow() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const galleries = [
    {
      title: t("golfAndGrowCategoryPatio"),
      images: golfAndGrowPatioImages,
      bg: "bg-app-blue-light",
      pill: "bg-app-blue-4",
    },
    {
      title: t("golfAndGrowCategoryDrivingRange"),
      images: golfAndGrowDrivingRangeImages,
      bg: "bg-app-grey",
      pill: "bg-app-gold",
    },
    {
      title: t("golfAndGrowCategoryCoaching"),
      images: golfAndGrowCoachingImages,
      bg: "bg-app-blue-light",
      pill: "bg-app-navy",
    },
  ];

  return (
    <div>
      {/* Hero */}
      <section>
        <div className="relative">
          <img
            src={heroBanner}
            alt="Golf & Grow Junior Clinic main banner"
            className="object-cover object-center w-full max-h-[50vh] sm:max-h-[65vh]"
          />
          <div className="absolute top-0 bottom-0 left-0 right-0 text-white bg-gradient-to-t from-app-navy/80 via-app-navy/40 to-app-gold/20">
            <div className="flex flex-col items-center justify-center h-full gap-3 app-main-container sm:gap-5">
              <span className="px-4 py-1 text-xs font-bold uppercase rounded-full sm:text-sm bg-app-gold text-app-navy app-animation-translate-start">
                {t("golfAndGrowSubtitle")}
              </span>
              <p className="max-w-lg px-4 text-2xl font-extrabold text-center sm:text-5xl app-animation-translate-start">
                {t("golfAndGrowBannerText")}
              </p>
              <div
                onClick={() =>
                  navigate("/prices", { state: { golfNGrow: true } })
                }
              >
                <button className="px-8 py-3 mt-2 text-sm font-bold transition-all rounded-full shadow-lg sm:text-base bg-app-gold text-app-navy hover:opacity-90 app-animation-translate-start">
                  {t("golfAndGrowRegisterButton")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Description */}
      <section className="relative overflow-hidden bg-app-grey">
        <div
          className="absolute w-40 h-40 rounded-full -top-10 -left-10 bg-app-gold/30"
          aria-hidden="true"
        />
        <div
          className="absolute bottom-0 right-0 w-56 h-56 rounded-full bg-app-blue-4/20"
          aria-hidden="true"
        />
        <div className="relative app-main-container">
          <p className="text-2xl font-extrabold text-center sm:text-3xl text-app-blue app-animation-translate-start">
            {t("golfAndGrowTitle")}
          </p>
          <div className="max-w-3xl mx-auto mt-6 space-y-4 text-sm leading-relaxed text-center sm:text-base text-app-blue-3 app-animation-translate-start">
            <p>{t("golfAndGrowParagraph1")}</p>
            <p>{t("golfAndGrowParagraph2")}</p>
            <p>{t("golfAndGrowParagraph3")}</p>
          </div>
          <div className="flex justify-center mt-8">
            <div
              onClick={() =>
                navigate("/prices", { state: { golfNGrow: true } })
              }
            >
              <button className="px-10 py-3 text-sm font-bold text-white transition-all rounded-full shadow-md sm:text-base bg-app-blue hover:bg-app-blue-4 disabled:opacity-50">
                {t("golfAndGrowRegisterButton")}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Category galleries */}
      <section>
        <div className="app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl text-app-blue-3 app-animation-translate-start">
            {t("golfAndGrowGalleryTitle")}
          </p>
        </div>
        <div className="pb-8 space-y-8">
          {galleries.map((gallery, i) => (
            <div key={i} className={`${gallery.bg}`}>
              <div className="app-main-container">
                <div className="flex justify-center mb-4">
                  <span
                    className={`px-5 py-1.5 rounded-full text-xs sm:text-sm font-bold uppercase text-white ${gallery.pill} app-animation-translate-start`}
                  >
                    {gallery.title}
                  </span>
                </div>
                <div className="max-w-2xl py-2 mx-auto">
                  <ImgGallery images={gallery.images} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-app-blue">
        <div className="flex flex-col items-center gap-4 app-main-container">
          <p className="text-lg font-bold text-center text-white sm:text-2xl app-animation-translate-start">
            {t("golfAndGrowTitle")}
          </p>
          <div
            onClick={() => navigate("/prices", { state: { golfNGrow: true } })}
          >
            <button className="px-10 py-3 text-sm font-bold transition-all rounded-full shadow-md sm:text-base bg-app-gold text-app-navy hover:opacity-90">
              {t("golfAndGrowRegisterButton")}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default GolfAndGrow;
